export const setSurveyHasCampaign = () => {
  if (window.survey && window.survey.surveyManager && window.survey.hasCampaign === false) {
    window.survey.hasCampaign = true;
    window.survey.surveyManager.trigger();
  }
};

export const createDOMContainer = () => {
  let DOMContainer;
  if (document.getElementById('survey-container')) {
    DOMContainer = document.getElementById('survey-container');
  } else {
    DOMContainer = document.createElement('div');
    DOMContainer.setAttribute('id', 'survey-container');
  }
  return DOMContainer;
};
